<template>
  <div>
    <Top title="Support" content="We are here to help you boost your dropshipping business with heart and soul." img="#FF9F85" imgMobile="/static/imgs/support_m.png"></Top>
    <div class="support">
      <div class="support_content">
        <div class="support_content_column">
          <div class="title_icon support_content_column_symbol"></div>
          <div class="support_content_column_title">Email</div>
          <div class="support_content_column_text">Drop an email with your questions or inspirations! We will answer asap.</div>
          <div class="support_content_column_btn" @click="goLink('mailto:apps@antdiy.vip')">
            <img src="../assets/icon_email.svg" alt="" />
            <span class="support_content_column_btn_text">Send email to us</span>
          </div>
        </div>
        <div class="support_content_column">
          <div class="title_icon support_content_column_symbol"></div>
          <div class="support_content_column_title">Live Chat</div>
          <div class="support_content_column_text">Message us for trouble shooting. We are right there to start a live chat.</div>
          <div class="support_content_column_btn" @click="openChat">
            <img src="../assets/icon_chat.svg" alt="" />
            <span class="support_content_column_btn_text">Click to live chat</span>
          </div>
          <div class="support_or_m">or click on the chat box in bottom right corner of page</div>
        </div>
        <div class="support_content_column">
          <div class="title_icon support_content_column_symbol"></div>
          <div class="support_content_column_title">Facebook</div>
          <div class="support_content_column_text">Follow our Facebook page to get the latest informations about ANTDIY and dropshipping.</div>
          <div class="support_content_column_btn" @click="goLink('https://www.facebook.com/ANTDIY-AliExpress-Dropshipping-Partner-112782580412393')">
            <img src="../assets/icon_facebook.svg" alt="" />
            <span class="support_content_column_btn_text">Follow our facebook</span>
          </div>
        </div>
      </div>
      <div class="support_or">or click on the chat box in bottom right corner of page</div>
      <!-- <div class="support_take" @click="goLink('https://apps.shopify.com/antfactory?surface_detail=antdiy&surface_inter_position=1&surface_intra_position=1&surface_type=search')">Take your business to the next level Try it now risk free.</div> -->
    </div>
    <Footer></Footer>
  </div>
</template>

<script>

import Footer from './common/footer.vue'
import Top from './common/top.vue'

export default {
  name: 'Support',
  components: {
    Footer,
    Top
  },
  methods: {
    goLink (url) {
      window.open(url)
    },
    openChat () {
      try {
        if (window.Tawk_API) {
          window.Tawk_API.maximize();
        }
        return
        window.fcWidget.open()
      } catch (error) {
        
      }
    }
  }
}
</script>

<style scoped>
.support{
  width: 1200px;
  margin: 0 auto;
  padding: 134px 0 124px;
}
.support_content{
  display: flex;

}
.support_content_column{
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 48px;
}
.support_content_column + .support_content_column{
  margin-left: 21px;
}
.support_content_column_title{
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  margin: 13px 0 16px;
}
.support_content_column_text{
  font-size: 20px;
  font-family: Helvetica;
  color: #222536;
  line-height: 28px;
  text-align: center;
  margin-bottom: 27px;
}
.support_content_column_btn{
  width: 240px;
  height: 48px;
  border-radius: 4px;
  border: 2px solid #FC5322;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.support_or_m{
  display: none;
}
.support_content_column_btn:hover{
  background: #FFF7F5;
  border-radius: 4px;
  border: 2px solid #FC5322;
}
.support_content_column_btn img{
  width: 24px;
  height: 24px;
}
.support_content_column_btn_text{
  font-size: 16px;
  font-family: Helvetica;
  color: #FC5421;
  line-height: 20px;
  margin-left: 10px;
}
.support_or{
  font-size: 14px;
  font-family: Helvetica;
  color: #8D919B;
  line-height: 24px;
  margin: 17px 0 144px;
  text-align: center;
}
.support_take{
  font-size: 16px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
}
.support_take:hover, .support_take:active{
  color: #FC5421;
}

@media (max-width: 767px){
  .support {
    width: 100%;
    padding: 1.15rem 0;
  }
  .support_content{
    flex-direction: column;
  }
  .support_content_column{
    padding: 0 .46rem;
  }
  .support_content_column + .support_content_column{
    margin-top: 1.15rem;
    margin-left: 0;
  }
  .support_content_column_title{
    font-size: .42rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: .58rem;
    margin: .4rem 0 .38rem;
  }
  .support_content_column_text{
    margin-bottom: .38rem;
    font-size: .31rem;
    font-family: Helvetica;
    color: #222536;
    line-height: .47rem;
  }
  .support_or, .support_take{
    display: none;
  }
  .support_or_m{
    font-size: .2rem;
    font-family: Helvetica;
    color: #8D919B;
    line-height: .23rem;
    margin-top: .19rem;
  }
}    
</style>



// WEBPACK FOOTER //
// src/components/support.vue